/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopePlayerListDto,
  ApiEnvelopePlayerListEmptyDto,
  ApiEnvelopePlayerListEntriesResponse,
  ApiEnvelopePlayerListEntryDto,
  ApiEnvelopePlayerListImportResultDto,
  ApiEnvelopePlayerListListResponse,
  ApiEnvelopePlayerListSearchResponse,
  PlayerListAddEntryRequest,
  PlayerListCreateRequest,
  PlayerListImportEntriesBody,
  PlayerListNoteRequest,
  PlayerListRenameRequest,
  PlayerListSearchParams,
  ProblemDetails
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type playerListListPlayerListsResponse200 = {
  data: ApiEnvelopePlayerListListResponse
  status: 200
}

export type playerListListPlayerListsResponseSuccess = (playerListListPlayerListsResponse200) & {
  headers: Headers;
};
;

export type playerListListPlayerListsResponse = (playerListListPlayerListsResponseSuccess)

export const getPlayerListListPlayerListsUrl = () => {




  return `/api/playerlists`
}

export const usePlayerListListPlayerListsHook = (): ( options?: RequestInit) => Promise<playerListListPlayerListsResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getPlayerListListPlayerListsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type playerListCreatePlayerListResponse200 = {
  data: ApiEnvelopePlayerListDto
  status: 200
}

export type playerListCreatePlayerListResponse400 = {
  data: ApiEnvelopePlayerListDto
  status: 400
}

export type playerListCreatePlayerListResponse403 = {
  data: ApiEnvelopePlayerListDto
  status: 403
}

export type playerListCreatePlayerListResponseSuccess = (playerListCreatePlayerListResponse200) & {
  headers: Headers;
};
export type playerListCreatePlayerListResponseError = (playerListCreatePlayerListResponse400 | playerListCreatePlayerListResponse403) & {
  headers: Headers;
};

export type playerListCreatePlayerListResponse = (playerListCreatePlayerListResponseSuccess | playerListCreatePlayerListResponseError)

export const getPlayerListCreatePlayerListUrl = () => {




  return `/api/playerlists`
}

export const usePlayerListCreatePlayerListHook = (): (playerListCreateRequest?: PlayerListCreateRequest, options?: RequestInit) => Promise<playerListCreatePlayerListResponse> => {

      const customFetcher = useSfetchMutator();
      return (playerListCreateRequest?: PlayerListCreateRequest, options?: RequestInit) => {

        return customFetcher(getPlayerListCreatePlayerListUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(playerListCreateRequest)
  }
);
      }
  }


export type playerListRenamePlayerListResponse200 = {
  data: ApiEnvelopePlayerListDto
  status: 200
}

export type playerListRenamePlayerListResponse400 = {
  data: ApiEnvelopePlayerListDto
  status: 400
}

export type playerListRenamePlayerListResponse403 = {
  data: ApiEnvelopePlayerListDto
  status: 403
}

export type playerListRenamePlayerListResponse404 = {
  data: ApiEnvelopePlayerListDto
  status: 404
}

export type playerListRenamePlayerListResponseSuccess = (playerListRenamePlayerListResponse200) & {
  headers: Headers;
};
export type playerListRenamePlayerListResponseError = (playerListRenamePlayerListResponse400 | playerListRenamePlayerListResponse403 | playerListRenamePlayerListResponse404) & {
  headers: Headers;
};

export type playerListRenamePlayerListResponse = (playerListRenamePlayerListResponseSuccess | playerListRenamePlayerListResponseError)

export const getPlayerListRenamePlayerListUrl = (id: string,) => {




  return `/api/playerlists/${id}`
}

export const usePlayerListRenamePlayerListHook = (): (id: string,
    playerListRenameRequest?: PlayerListRenameRequest, options?: RequestInit) => Promise<playerListRenamePlayerListResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    playerListRenameRequest?: PlayerListRenameRequest, options?: RequestInit) => {

        return customFetcher(getPlayerListRenamePlayerListUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(playerListRenameRequest)
  }
);
      }
  }


export type playerListDeletePlayerListResponse200 = {
  data: ApiEnvelopePlayerListEmptyDto
  status: 200
}

export type playerListDeletePlayerListResponse403 = {
  data: ApiEnvelopePlayerListEmptyDto
  status: 403
}

export type playerListDeletePlayerListResponse404 = {
  data: ApiEnvelopePlayerListEmptyDto
  status: 404
}

export type playerListDeletePlayerListResponseSuccess = (playerListDeletePlayerListResponse200) & {
  headers: Headers;
};
export type playerListDeletePlayerListResponseError = (playerListDeletePlayerListResponse403 | playerListDeletePlayerListResponse404) & {
  headers: Headers;
};

export type playerListDeletePlayerListResponse = (playerListDeletePlayerListResponseSuccess | playerListDeletePlayerListResponseError)

export const getPlayerListDeletePlayerListUrl = (id: string,) => {




  return `/api/playerlists/${id}`
}

export const usePlayerListDeletePlayerListHook = (): (id: string, options?: RequestInit) => Promise<playerListDeletePlayerListResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getPlayerListDeletePlayerListUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type playerListGetEntriesResponse200 = {
  data: ApiEnvelopePlayerListEntriesResponse
  status: 200
}

export type playerListGetEntriesResponse403 = {
  data: ApiEnvelopePlayerListEntriesResponse
  status: 403
}

export type playerListGetEntriesResponse404 = {
  data: ApiEnvelopePlayerListEntriesResponse
  status: 404
}

export type playerListGetEntriesResponseSuccess = (playerListGetEntriesResponse200) & {
  headers: Headers;
};
export type playerListGetEntriesResponseError = (playerListGetEntriesResponse403 | playerListGetEntriesResponse404) & {
  headers: Headers;
};

export type playerListGetEntriesResponse = (playerListGetEntriesResponseSuccess | playerListGetEntriesResponseError)

export const getPlayerListGetEntriesUrl = (id: string,) => {




  return `/api/playerlists/${id}/entries`
}

export const usePlayerListGetEntriesHook = (): (id: string, options?: RequestInit) => Promise<playerListGetEntriesResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getPlayerListGetEntriesUrl(id),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type playerListAddEntryResponse200 = {
  data: ApiEnvelopePlayerListEntryDto
  status: 200
}

export type playerListAddEntryResponse400 = {
  data: ApiEnvelopePlayerListEntryDto
  status: 400
}

export type playerListAddEntryResponse403 = {
  data: ApiEnvelopePlayerListEntryDto
  status: 403
}

export type playerListAddEntryResponse404 = {
  data: ApiEnvelopePlayerListEntryDto
  status: 404
}

export type playerListAddEntryResponseSuccess = (playerListAddEntryResponse200) & {
  headers: Headers;
};
export type playerListAddEntryResponseError = (playerListAddEntryResponse400 | playerListAddEntryResponse403 | playerListAddEntryResponse404) & {
  headers: Headers;
};

export type playerListAddEntryResponse = (playerListAddEntryResponseSuccess | playerListAddEntryResponseError)

export const getPlayerListAddEntryUrl = (id: string,) => {




  return `/api/playerlists/${id}/entries`
}

export const usePlayerListAddEntryHook = (): (id: string,
    playerListAddEntryRequest?: PlayerListAddEntryRequest, options?: RequestInit) => Promise<playerListAddEntryResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    playerListAddEntryRequest?: PlayerListAddEntryRequest, options?: RequestInit) => {

        return customFetcher(getPlayerListAddEntryUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(playerListAddEntryRequest)
  }
);
      }
  }


export type playerListRemoveEntryResponse200 = {
  data: ApiEnvelopePlayerListEmptyDto
  status: 200
}

export type playerListRemoveEntryResponse403 = {
  data: ApiEnvelopePlayerListEmptyDto
  status: 403
}

export type playerListRemoveEntryResponse404 = {
  data: ApiEnvelopePlayerListEmptyDto
  status: 404
}

export type playerListRemoveEntryResponseSuccess = (playerListRemoveEntryResponse200) & {
  headers: Headers;
};
export type playerListRemoveEntryResponseError = (playerListRemoveEntryResponse403 | playerListRemoveEntryResponse404) & {
  headers: Headers;
};

export type playerListRemoveEntryResponse = (playerListRemoveEntryResponseSuccess | playerListRemoveEntryResponseError)

export const getPlayerListRemoveEntryUrl = (id: string,
    entryId: string,) => {




  return `/api/playerlists/${id}/entries/${entryId}`
}

export const usePlayerListRemoveEntryHook = (): (id: string,
    entryId: string, options?: RequestInit) => Promise<playerListRemoveEntryResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    entryId: string, options?: RequestInit) => {

        return customFetcher(getPlayerListRemoveEntryUrl(id,entryId),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type playerListSetEntryNoteResponse200 = {
  data: ApiEnvelopePlayerListEntryDto
  status: 200
}

export type playerListSetEntryNoteResponse403 = {
  data: ApiEnvelopePlayerListEntryDto
  status: 403
}

export type playerListSetEntryNoteResponse404 = {
  data: ApiEnvelopePlayerListEntryDto
  status: 404
}

export type playerListSetEntryNoteResponseSuccess = (playerListSetEntryNoteResponse200) & {
  headers: Headers;
};
export type playerListSetEntryNoteResponseError = (playerListSetEntryNoteResponse403 | playerListSetEntryNoteResponse404) & {
  headers: Headers;
};

export type playerListSetEntryNoteResponse = (playerListSetEntryNoteResponseSuccess | playerListSetEntryNoteResponseError)

export const getPlayerListSetEntryNoteUrl = (id: string,
    entryId: string,) => {




  return `/api/playerlists/${id}/entries/${entryId}/note`
}

export const usePlayerListSetEntryNoteHook = (): (id: string,
    entryId: string,
    playerListNoteRequest?: PlayerListNoteRequest, options?: RequestInit) => Promise<playerListSetEntryNoteResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    entryId: string,
    playerListNoteRequest?: PlayerListNoteRequest, options?: RequestInit) => {

        return customFetcher(getPlayerListSetEntryNoteUrl(id,entryId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(playerListNoteRequest)
  }
);
      }
  }


export type playerListExportEntriesResponse200 = {
  data: Blob
  status: 200
}

export type playerListExportEntriesResponse404 = {
  data: ProblemDetails
  status: 404
}

export type playerListExportEntriesResponseSuccess = (playerListExportEntriesResponse200) & {
  headers: Headers;
};
export type playerListExportEntriesResponseError = (playerListExportEntriesResponse404) & {
  headers: Headers;
};

export type playerListExportEntriesResponse = (playerListExportEntriesResponseSuccess | playerListExportEntriesResponseError)

export const getPlayerListExportEntriesUrl = (id: string,) => {




  return `/api/playerlists/${id}/export`
}

export const usePlayerListExportEntriesHook = (): (id: string, options?: RequestInit) => Promise<playerListExportEntriesResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getPlayerListExportEntriesUrl(id),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type playerListImportEntriesResponse200 = {
  data: ApiEnvelopePlayerListImportResultDto
  status: 200
}

export type playerListImportEntriesResponse400 = {
  data: ApiEnvelopePlayerListImportResultDto
  status: 400
}

export type playerListImportEntriesResponse403 = {
  data: ApiEnvelopePlayerListImportResultDto
  status: 403
}

export type playerListImportEntriesResponse404 = {
  data: ApiEnvelopePlayerListImportResultDto
  status: 404
}

export type playerListImportEntriesResponseSuccess = (playerListImportEntriesResponse200) & {
  headers: Headers;
};
export type playerListImportEntriesResponseError = (playerListImportEntriesResponse400 | playerListImportEntriesResponse403 | playerListImportEntriesResponse404) & {
  headers: Headers;
};

export type playerListImportEntriesResponse = (playerListImportEntriesResponseSuccess | playerListImportEntriesResponseError)

export const getPlayerListImportEntriesUrl = (id: string,) => {




  return `/api/playerlists/${id}/import`
}

export const usePlayerListImportEntriesHook = (): (id: string,
    playerListImportEntriesBody?: PlayerListImportEntriesBody, options?: RequestInit) => Promise<playerListImportEntriesResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    playerListImportEntriesBody?: PlayerListImportEntriesBody, options?: RequestInit) => {
        const formData = new FormData();
if(playerListImportEntriesBody?.file !== undefined) {
 formData.append(`file`, playerListImportEntriesBody.file);
 }
if(playerListImportEntriesBody?.dryRun !== undefined) {
 formData.append(`dryRun`, playerListImportEntriesBody.dryRun.toString())
 }

        return customFetcher(getPlayerListImportEntriesUrl(id),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);
      }
  }


export type playerListSearchResponse200 = {
  data: ApiEnvelopePlayerListSearchResponse
  status: 200
}

export type playerListSearchResponseSuccess = (playerListSearchResponse200) & {
  headers: Headers;
};
;

export type playerListSearchResponse = (playerListSearchResponseSuccess)

export const getPlayerListSearchUrl = (params?: PlayerListSearchParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/playerlists/search?${stringifiedParams}` : `/api/playerlists/search`
}

export const usePlayerListSearchHook = (): (params?: PlayerListSearchParams, options?: RequestInit) => Promise<playerListSearchResponse> => {

      const customFetcher = useSfetchMutator();
      return (params?: PlayerListSearchParams, options?: RequestInit) => {

        return customFetcher(getPlayerListSearchUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


